import { FiltrosLicitacoes } from "@/types/licitacoes/ldi/filtros-licitacoes";
import { PortalError } from "@/types/portal-error";
import { Service } from "../mainService";
import { Licitacao } from "@/types/licitacoes/ldi/licitacao";
import { ParticipanteLicitacao } from "@/types/licitacoes/ldi/participante-licitacao";
import { ItemLicitacao } from "@/types/licitacoes/ldi/item-licitacao";
import { LoteLicitacao } from "@/types/licitacoes/ldi/lote-licitacao";
import { LicitacaoHomologacao } from "@/types/licitacoes/ldi/licitacao-homologacao";
import { RetornoBuscarVencedores } from "@/types/licitacoes/ldi/retornos/retorno-buscar-vencedores";
import { LicitacaoVencedorLote } from "@/types/licitacoes/ldi/licitacao-vencedor-lote";
import { RetornoBuscarVencedoresItem } from "@/types/licitacoes/ldi/retornos/retorno-buscar-vencedores-item";
import { LicitacaoVencedorItem } from "@/types/licitacoes/ldi/licitacao-vencedor-item";
import { LoteLicitacaoParcial } from "@/types/licitacoes/ldi/retornos/lote-licitacao-parcial";
import { VencedorItem } from "@/types/licitacoes/ldi/vencedor-item";
import { CancelamentoLicitacaoDto } from "@/types/licitacoes/ldi/cancelamento-licitacao-dto";
import { LicitacaoDadosCancelamento } from "@/types/licitacoes/ldi/licitacao-dados-cancelamento";
import { SelectValue } from "@/types/select-value";
import { RetornoImportarLicitacoes } from "@/types/licitacoes/ldi/retornos/retorno-importar-licitacoes";
import { ItemModalVencedorLicitacao } from "@/types/licitacoes/ldi/item-modal-vencedor-licitacao";
import { RetornoModalVencedorLicitacao } from "@/types/licitacoes/ldi/retornos/retorno-modal-vencedor-licitacao";

const ldiService = {
  //geral
  filtrarLicitacoes,
  buscarHistorico,
  buscarVencedores,
  buscarItensEdicaoVencedores,
  buscarItensModalVencedores,
  buscarDadosGerais,
  buscarDadosHomologacao,
  buscarLotes,
  buscarItens,
  buscarFracassados,
  buscarParticipantes,
  buscarListaParticipantes,
  buscarItensLote,
  buscarLotePorId,
  buscarFracassadosVencedores,
  buscarItem,

  //saves
  salvarDadosIniciais,
  adicionarParticipanteLicitacao,
  adicionarItemLicitacao,
  adicionarLoteLicitacao,
  adicionarItemLote,
  alterarItemLoteVencido,
  salvarDadosHomologacao,
  alterarVencedorLoteLicitacao,
  alterarVencedorItemLicitacao,
  alterarLoteFracassado,
  alterarItemFracassado,
  salvarItensPorVencedor,

  //remoções
  removerItemLote,
  removerItemLicitacao,
  removerLoteLicitacao,
  removerParticipanteLicitacao,

  //GETs acessórios
  buscarSituacao,
  listarPendenciasLicitacao,
  baixarAnexo,
  listarModalidades,
  listarRefBasesLegais,
  listarSituacoes,
  getCombosLicitacao,
  getCombosDI,

  //paradas de cancelamento
  buscarInformacoesCancelamento,
  buscarOpcoesDeCancelamento,
  cancelarLdi,
  cancelarLdiCancelada,
  removerLicitacao,

  //importação de arquivos
  importarLotesPlanilha,
  importarLicitacoes,
  baixarModeloImportacaoItem,
  baixarRelatorioInconsistencias,
  baixarRelatorioPendencias,

  //auxiliares internacionais
  getListaTldPaises,
};

async function filtrarLicitacoes(
  page: number,
  pageSize: number,
  filtros: FiltrosLicitacoes
): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API
      }/licitacao/filtrarLicitacoes?page=${page}&pageSize=${pageSize}${filtros.toQueryString()}`;
    const response = await Service.$http.get(url);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.error("Falha ao filtrarLicitacoes", response);
      throw new PortalError(
        response.data?.msg ||
        "Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!"
      );
    }
  } catch (e: any) {
    console.error("Falha ao filtrar licitações", e);
    throw new PortalError(e.response.data.msg ?? e);
  }
}

async function listarModalidades(tipo: string) {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/listarModalidades/" +
      tipo;
    const response = await Service.$http.get(url);

    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function listarRefBasesLegais(idModalidade: number) {
  const url =
    process.env.VUE_APP_LICITACOES_API +
    "/licitacao/listarReferenciasLegais/" +
    idModalidade;
  const response = await Service.$http.get(url);
  return response;
}

async function listarSituacoes() {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API + "/licitacao/listarSituacoes/";
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function buscarHistorico(
  idLicitacao: number,
  page: number,
  size: number
): Promise<any> {
  try {
    //console.log("call buscarHistorico", idLicitacao);
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarLogs/${idLicitacao}?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);
    if (response && response.status === 200) return response.data;
    else {
      console.error("Falha ao buscar histórico de licitação", response);
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}
async function buscarVencedores(
  idLicitacao: number,
  page: number,
  size: number
): Promise<RetornoBuscarVencedores> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarVencedores/${idLicitacao}?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);
    //console.log("buscarVencedores do SERVICE recebeu", response);
    if (response && response.status === 200) {
      const rbv = new RetornoBuscarVencedores();
      rbv.montarObjeto(response.data);
      return rbv;
    } else {
      console.error(response);
      throw new PortalError("Falha ao buscar vencedores de licitação");
    }
  } catch (e: any) {
    console.error("Falha ao buscar vencedores de licitação", e);
    throw e;
  }
}

async function buscarItensEdicaoVencedores(
  idLicitacao: number,
  page: number,
  size: number,
  texto?: string
): Promise<RetornoBuscarVencedoresItem> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API
      }/licitacao/buscarItens/${idLicitacao}${texto ? `/${texto}` : ""
      }?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);
    /*     console.log(
      "buscarItens para tela Vencedores recebeu do SERVICE os itens: ",
      response
    ); */
    if (response && response.status === 200) {
      const rbv = new RetornoBuscarVencedoresItem();
      rbv.montarObjeto(response.data);
      return rbv;
    } else {
      console.error(response);
      throw new PortalError("Falha ao buscar vencedores de licitação");
    }
  } catch (e: any) {
    console.error("Falha ao buscar vencedores de licitação", e);
    throw e;
  }
}

async function buscarItensModalVencedores(
  idLicitacao: number,
  idParticipante: number,
  page = 1,
  pageSize = 50,
  texto = ""
): Promise<RetornoModalVencedorLicitacao> {
  const filtro = texto.trim();
  const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarItens/${idLicitacao}${filtro ? `/${encodeURIComponent(filtro)}` : ""
    }?page=${page}&pageSize=${pageSize}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200) {
    return new RetornoModalVencedorLicitacao(
      response.data,
      idParticipante,
      page,
      pageSize
    );
  }
  throw new PortalError("Falha ao buscar vencedores de licitação");
}

async function salvarItensPorVencedor(
  IdLicitacao: number,
  IdParticipanteLicitacao: number,
  items: ItemModalVencedorLicitacao[]
): Promise<boolean> {
  const jsonForm = {
    IdLicitacao,
    IdParticipanteLicitacao,
    Itens: items.map((i) => {
      return {
        IdItemLicitacao: i.IdItemLicitacao,
        QtItem: i.QtLicitada,
        VlUnitarioLicitado: i.VlUnitarioLicitado,
        NmMarcaItemMatServ: i.NmMarcaItemMatServ,
      };
    }),
  };
  const response = await Service.$http.post(
    process.env.VUE_APP_LICITACOES_API +
    "/licitacao/alterarVencedorItemLicitacaoBatch",
    jsonForm
  );
  if (response.status === 200) return response.data;
  console.error("Falha ao salvar itens por vencedor", response);
  throw new PortalError("Falha ao salvar os itens por vencedor");
}

/** Este tipo de método retorna any porque além do array do objeto vem totalRows, page e pageSize.
 * Poderíamos ter uma classe com estes dados e um array de tipo escolhido pelo user,
 * pra centralizar aqui nos services a montagem de cada instância.
 */
async function buscarParticipantes(
  idLicitacao: number,
  page?: number,
  size?: number
): Promise<any> {
  try {
    let url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarParticipantes/${idLicitacao}`;
    if (page && size) {
      url += `?page=${page}&pageSize=${size}`;
    }
    const response = await Service.$http.get(url);
    /* console.log(
      "ldiService.buscarParticipantes trouxe",
      response,
      process.env.NODE_ENV
    ); */
    if (response && response.status === 200) return response.data;
    else {
      console.error(
        "Falha ao buscar participantes/itens de licitação",
        response
      );
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}

async function buscarListaParticipantes(
  idLicitacao: number
): Promise<SelectValue[]> {
  const response = await buscarParticipantes(idLicitacao, 1, 0);
  if (response && response.participantes && response.participantes.length > 0) {
    const svs = response.participantes.map((p) => {
      return { text: p.NmParticipante, value: p.IdParticipanteLicitacao };
    });
    return svs;
  } else return [];
}

async function buscarItens(
  idLicitacao: number,
  page: number,
  size: number,
  texto?: string
): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API
      }/licitacao/buscarItens/${idLicitacao}${texto ? `/${texto}` : ""
      }?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);

    if (response && response.status === 200) return response.data;
    else {
      console.error("Falha ao buscar itens de licitação", response);
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}

async function buscarItem(idItem: number): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarItem/${idItem}`;
    const response = await Service.$http.get(url);

    if (response && response.status === 200) return response.data;
    else {
      console.error("Falha ao buscar itens de licitação", response);
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}

async function buscarItensLote(
  idLote: number,
  page: number,
  size: number,
  texto?: string
): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API
      }/licitacao/buscarItensLote/${idLote}${texto ? `/${texto}` : ""
      }?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);

    if (response && response.status === 200) return response.data;
    else {
      console.error("Falha ao buscar itens do lote", response);
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}

async function buscarLotes(
  idLicitacao: number,
  page: number,
  size: number,
  texto?: string
): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API
      }/licitacao/buscarLotes/${idLicitacao}${texto ? `/${texto}` : ""
      }?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);

    if (response && response.status === 200) return response.data;
    else {
      console.error("Falha ao buscar lotes de licitação", response);
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}

async function buscarDadosGerais(idLicitacao: string): Promise<Licitacao> {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/buscarDadosGerais/" +
      idLicitacao;
    const response = await Service.$http.get(url);
    const licitacao = Object.assign(new Licitacao(), response.data.licitacao);
    licitacao.tratarDadosDaAPI(
      response.data.IsDispensaInexigibilidade,
      response.data.IsLote,
      response.data.countItens,
      response.data.countLotes
    );
    return licitacao;
  } catch (e: any) {
    return e.response.data;
  }
}

async function buscarDadosHomologacao(
  idLicitacao: string
): Promise<LicitacaoHomologacao> {
  const url =
    process.env.VUE_APP_LICITACOES_API +
    "/licitacao/buscarDadosHomologacao/" +
    idLicitacao;
  const response = await Service.$http.get(url);
  if (!response || response.status !== 200)
    throw new PortalError(
      "Falha ao buscar dados de homologação da licitação! Por favor recarregue a página."
    );
  const licitacao = Object.assign(new LicitacaoHomologacao(), response.data);
  licitacao.tratarDadosAPI();
  return licitacao;
}

async function baixarAnexo(id: string) {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/baixaranexo/" + id,
      { responseType: "blob" }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function buscarFracassados(
  idLicitacao: number,
  page: number,
  size: number
): Promise<any> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarItensFracassados/${idLicitacao}?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);

    if (response && response.status === 200) return response.data;
    else {
      console.error("Falha ao buscar fracassados de licitação", response);
      return null;
    }
  } catch (e: any) {
    return e.response;
  }
}

/**
 * @returns os combos que são utilizados para editar os dados iniciais de uma licitação
 * @since 20230426
 */
async function getCombosLicitacao() {
  //critérios de julgamento, modalidades, natureza do objeto, natureza da obra, bases legais
  try {
    const [rCrit, rMod, rObjeto, rObra] = await Promise.all([
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API +
        "/licitacao/listarCriteriosJulgamento"
      ),
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API +
        "/licitacao/listarModalidades/licitacao/vigentes"
      ),
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API + "/licitacao/listarNaturezasObjeto"
      ),
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API + "/licitacao/listarNaturezasObra"
      ),
    ]);
    return {
      criteriosJulgamento: rCrit.data,
      modalidades: rMod.data,
      naturezasObjeto: rObjeto.data,
      naturezasObra: rObra.data,
    };
  } catch (e: any) {
    return e.response;
  }
}

/**
 * @returns os combos que são utilizados para editar os dados iniciais de uma dispensa/inex
 * @since 20230828
 */
async function getCombosDI() {
  //modalidades, natureza do objeto, natureza da obra, bases legais
  try {
    const [rMod, rObjeto, rObra] = await Promise.all([
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API +
        "/licitacao/listarModalidades/dispensa/vigentes"
      ),
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API + "/licitacao/listarNaturezasObjeto"
      ),
      Service.$http.get(
        process.env.VUE_APP_LICITACOES_API + "/licitacao/listarNaturezasObra"
      ),
    ]);
    return {
      modalidades: rMod.data,
      naturezasObjeto: rObjeto.data,
      naturezasObra: rObra.data,
    };
  } catch (e: any) {
    return e.response;
  }
}

/**
 * Add
 * @param Licitacao lic
 * @returns Licitacao licitacao salva
 * @since 20230428
 */
async function salvarDadosIniciais(lic: Licitacao): Promise<Licitacao> {
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/salvarDadosIniciais",
      lic.toFormData()
    );
    if (response.status === 200) {
      const licita = Object.assign(new Licitacao(), response.data.licitacao);
      licita.tratarDadosDaAPI(
        response.data.IsDispensaInexigibilidade,
        response.data.IsLote
      );
      return licita;
    }
    throw new PortalError("Falha ao salvar dados iniciais da licitação");
  } catch (e: any) {
    console.error("capotou no service", e);
    if ([400, 403].includes(e.response?.status)) {
      throw montarArrayDeErros(e);
    }
    throw e;
  }
}

async function adicionarParticipanteLicitacao(
  pl: ParticipanteLicitacao
): Promise<ParticipanteLicitacao> {
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/salvarParticipante",
      pl.toFormData()
    );
    const novoPart = Object.assign(new ParticipanteLicitacao(), response.data);
    return novoPart;
  } catch (e: any) {
    console.error("Erro ao tentar salvar novo participante", e.response);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

async function removerParticipanteLicitacao(idPL: number): Promise<boolean> {
  try {
    const response = await Service.$http.delete(
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/removerParticipante/" +
      idPL
    );
    return response.status === 204;
  } catch (e: any) {
    console.error("Erro ao tentar remover participante de licitação", e);
    if (e.response.status === 400) {
      throw new PortalError(e.response.data.erros);
    } else {
      throw e;
    }
  }
}

async function adicionarItemLicitacao(
  il: ItemLicitacao
): Promise<ItemLicitacao> {
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/salvarItem",
      il.toFormData()
    );
    //console.log("service adicionarItemLicitacao", il, response);
    const novoPart = Object.assign(new ItemLicitacao(), response.data.item);
    novoPart.VlTotalEstimado = response.data.vlTotalEstimado;
    novoPart.VlTotalLicitado = response.data.vlTotalLicitado;
    return novoPart;
  } catch (e: any) {
    console.error("Erro ao tentar salvar novo item", e.response);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}
async function adicionarLoteLicitacao(
  il: LoteLicitacao
): Promise<LoteLicitacao> {
  try {
    const novoLote = Object.assign(new LoteLicitacao(), il);
    novoLote.DeLote = il.novaDeLote;
    novoLote.NuSequencialLote = il.novoNuSequencialLote;
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/salvarLote",
      novoLote.toFormData()
    );
    //console.log("service adicionarLoteLicitacao", il, response);
    if (response.status === 200) {
      return montarLote(response.data);
    } else throw new Error("Erro inesperado");
  } catch (e: any) {
    console.error("Erro ao tentar salvar novo lote", e.response);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}
async function adicionarItemLote(il: ItemLicitacao): Promise<ItemLicitacao> {
  try {
    //console.log("service salvarItemLote, lote:", il.IdLoteLicitacao);

    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/salvarItemLote/" +
      il.IdLoteLicitacao,
      il.toFormData()
    );
    //console.log("service salvarItemLote", il, response);
    const novoPart = Object.assign(new ItemLicitacao(), response.data);
    return novoPart;
  } catch (e: any) {
    console.error("Erro ao tentar salvar item do lote", e.response);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(
        e.response.data.erros ??
        e.response.data.msg ??
        "Falha ao salvar item do lote, por favor revise os dados."
      );
    } else {
      throw e;
    }
  }
}
async function alterarItemLoteVencido(
  il: ItemLicitacao
): Promise<LoteLicitacaoParcial> {
  try {
    /*     console.log(
      "service alterarItemLoteVencido, lote:",
      il.IdItemLoteLicitacao
    ); */

    const formData = new FormData();
    formData.append("VlUnitarioLicitado", String(il.VlUnitarioLicitado));
    formData.append("NmMarcaItemMatServ", il.NmMarcaItemMatServ);

    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/alterarItemLoteVencido/" +
      il.IdItemLoteLicitacao,
      formData
    );
    //console.log("service alterarItemLoteVencido", il, response);
    const novoLote = Object.assign(new LoteLicitacao(), response.data);
    return novoLote;
  } catch (e: any) {
    console.error("Erro ao tentar alterar item do lote (vencedor)", e.response);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}
async function removerItemLicitacao(idIL: number): Promise<boolean> {
  try {
    const response = await Service.$http.delete(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/removerItem/" + idIL
    );
    //console.log("service removerItemLicitacao", idIL, response);
    return response.status === 204;
  } catch (e: any) {
    console.error("Erro ao tentar remover item de licitação", e);
    if (e.response.status === 400) {
      throw new PortalError(e.response.data.erros);
    } else {
      throw e;
    }
  }
}

async function removerLoteLicitacao(idPL: number): Promise<boolean> {
  try {
    const response = await Service.$http.delete(
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/removerLoteLicitacao/" +
      idPL
    );
    //console.log("service removerLoteLicitacao", idPL, response);
    return response.status === 204;
  } catch (e: any) {
    console.error("Erro ao tentar remover lote de licitação", e);
    if (e.response.status === 400) {
      throw new PortalError(e.response.data.erros);
    } else {
      throw e;
    }
  }
}

async function removerItemLote(idPL: number): Promise<boolean> {
  try {
    //console.log("Remover item do lote nº: ", idPL);
    const response = await Service.$http.delete(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/removerItemLote/" + idPL
    );
    //console.log("service removerItemLote: ", response);
    return response.status === 204;
  } catch (e: any) {
    console.error("Erro ao tentar remover lote de licitação", e);
    if (e.response.status === 400) {
      throw new PortalError(e.response.data.erros);
    } else {
      throw e;
    }
  }
}

async function salvarDadosHomologacao(lh: LicitacaoHomologacao): Promise<any> {
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/salvarDadosHomologacao",
      lh.toFormData()
    );
    //console.log("service salvarDadosHomologacao", lh, response);
    const novoPart = Object.assign(new LicitacaoHomologacao(), response.data);
    return novoPart;
  } catch (e: any) {
    console.error("Erro ao tentar salvar dados de homologacao", e.response);
    if (
      e.response &&
      (e.response.status === 400 || e.response.status === 403)
    ) {
      throw new PortalError(
        e.response.data.erros ?? e.response.data.errors ?? e.response.data.msg
      );
    } else {
      throw e;
    }
  }
}

async function buscarLotePorId(idLote: number): Promise<LoteLicitacao> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarLote/${idLote}`;
    const response = await Service.$http.get(url);
    //console.log("response para buscarLotePorId", idLote, response);
    if (response && response.status === 200) {
      return montarLote(response.data);
    }
    throw new PortalError("Falha ao buscar lote em nossos servidores.");
  } catch (e: any) {
    console.error("Erro ao tentar buscar lote", e);
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

async function alterarVencedorLoteLicitacao(
  IdLoteLicitacao: number,
  IdParticipante: number,
  DtHomologacaoLote: Date | null = null
): Promise<LoteLicitacao> {
  try {
    const form = new FormData();
    form.append("IdLoteLicitacao", String(IdLoteLicitacao));
    form.append("IdParticipanteLicitacao", String(IdParticipante));
    if (DtHomologacaoLote)
      form.append("DtHomologacaoLote", DtHomologacaoLote.toISOString());

    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/alterarVencedorLoteLicitacao",
      form
    );
    //console.log("service alterarVencedorLoteLicitacao", response);

    if (response.status === 200) {
      //TO DO: Pedir pra Glauber mandar essa porra padronizada pra usar o montarLote()
      const novoLote = Object.assign(
        new LoteLicitacao(),
        response.data.loteLicitacao
      );
      novoLote.IsLotePreenchido = response.data.IsLotePreenchido;
      return novoLote;
    } else throw new Error("Erro inesperado");
  } catch (e: any) {
    console.error("Erro ao tentar salvar vencedor de lote", e.response);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

async function alterarVencedorItemLicitacao(
  IdItemLicitacao: number,
  vencedorItem: VencedorItem,
  FlVencedor: string
): Promise<VencedorItem> {
  try {
    const form = new FormData();
    form.append("IdItemLicitacao", String(IdItemLicitacao));
    form.append(
      "IdParticipanteLicitacao",
      String(vencedorItem.IdParticipanteLicitacao)
    );
    form.append("QtItem", String(vencedorItem.QtLicitada));
    form.append("VlUnitarioLicitado", String(vencedorItem.VlUnitarioLicitado));
    if (vencedorItem.NmMarcaItemMatServ)
      form.append("NmMarcaItemMatServ", vencedorItem.NmMarcaItemMatServ);
    if (vencedorItem.DtHomologacaoItem)
      form.append(
        "DtHomologacaoItem",
        vencedorItem.DtHomologacaoItem.toISOString()
      );

    if (vencedorItem.IdParticipanteItemLicitacao)
      form.append(
        "IdParticipanteItemLicitacao",
        String(vencedorItem.IdParticipanteItemLicitacao)
      );

    form.append("FlVencedor", FlVencedor);

    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
      "/licitacao/alterarVencedorItemLicitacao",
      form
    );
    //console.log("service alterarVencedorItemLicitacao", response);

    if (response && response.status === 200) {
      const novoItem = new VencedorItem();
      novoItem.inicializarRetorno(response.data.participanteItem);
      /*Object.assign(
        new VencedorItem(),
        response.data.participanteItem.IdParticipanteLicitacaoNavigation
      );*/
      //console.log("novoItem pós inicializar retorno", novoItem);
      return novoItem;
    } else throw new Error("Erro inesperado");
  } catch (e: any) {
    console.error("Erro ao tentar salvar vencedor de item", e.response);
    if (
      e.response &&
      (e.response.status === 400 || e.response.status === 403)
    ) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

async function alterarLoteFracassado(
  lvl: LicitacaoVencedorLote
): Promise<LicitacaoVencedorLote> {
  try {
    //console.log("ldiService Fracassar: ", lvl);
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
      `/licitacao/alterarLoteFracassado/${lvl.IdLoteLicitacao}/${lvl.FlFracassado === "Não" ? "S" : "N"
      }`
    );
    //console.log("service alterarLoteFracassado", response);
    if (response.status === 200) {
      const novoLvl = Object.assign(new LicitacaoVencedorLote(), response.data);
      novoLvl.tratarDadosDaAPI();
      return novoLvl;
    } else throw new Error("Erro inesperado");
  } catch (e: any) {
    console.error(
      "Erro ao tentar alterar o status de lote (fracassar)",
      e.response
    );
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

async function alterarItemFracassado(
  lvl: LicitacaoVencedorItem
): Promise<LicitacaoVencedorItem> {
  try {
    //console.log("ldiService Fracassar: ", lvl);
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
      `/licitacao/alterarItemFracassado/${lvl.IdItemLicitacao}/${lvl.FlFracassado === "Não" ? "S" : "N"
      }`
    );
    //console.log("service alterarItemFracassado", response);
    if (response.status === 200) {
      const novoLvl = Object.assign(new LicitacaoVencedorItem(), response.data);
      novoLvl.tratarDadosDaAPI();
      return novoLvl;
    } else throw new Error("Erro inesperado");
  } catch (e: any) {
    console.error("Erro ao tentar alterar o status de item (fracassar)", e);
    if (e.response?.status === 400 || e.response?.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

async function buscarFracassadosVencedores( // Função que retorna os fracassados para visualização na aba vencedores da licitação.
  idLicitacao: number,
  page: number,
  size: number
): Promise<RetornoBuscarVencedoresItem> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarItensFracassados/${idLicitacao}?page=${page}&pageSize=${size}`;
    const response = await Service.$http.get(url);

    if (response && response.status === 200) {
      const rbv = new RetornoBuscarVencedoresItem();
      rbv.montarObjeto(response.data);
      return rbv;
    } else {
      console.error(response);
      throw new PortalError("Falha ao buscar vencedores de licitação");
    }
  } catch (e: any) {
    return e.response;
  }
}

// métodos de importação
async function importarLotesPlanilha(
  modo: string,
  idLic: number,
  data: FormData
): Promise<ItemLicitacao[]> {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API +
      `/licitacao/${modo === "item"
        ? "importarItensLicitacao"
        : modo === "dispensa"
          ? "importarItensDispensa"
          : "importarItensLoteLicitacao"
      }/` +
      idLic;
    const response = await Service.$http.post(url, data);
    //console.log("ldiService.importarLotesPlanilha recebeu", response);
    if (response && response.status === 200) return response.data;
    throw new PortalError(
      response.data.erros ?? response.data.msg ?? "Erro ao importar itens"
    );
  } catch (e: any) {
    console.error("ldiService.importarLotesPlanilha falhou", e);
    throw montarArrayDeErros(e);
  }
}

async function importarLicitacoes(
  arquivo: File
): Promise<RetornoImportarLicitacoes> {
  try {
    const url = process.env.VUE_APP_LICITACOES_API + "/licitacao/importar/xml";
    const formData = new FormData();
    formData.append("zipFile", arquivo);
    const response = await Service.$http.post(url, formData);
    //console.log("ldiService.importarLicitacoes recebeu", response);
    if (response && response.status === 200)
      return new RetornoImportarLicitacoes(response.data);
    throw new PortalError(response.data.msg ?? "Erro ao importar licitações");
  } catch (e: any) {
    if (e.response?.status === 400 && e.response?.data)
      return new RetornoImportarLicitacoes(e.response.data);
    throw new PortalError(e.response.data.msg ?? "Erro ao importar licitações");
  }
}

/**
 *
 * @param tipo precisa ser 'itens' ou 'itensLote'
 * @returns xlsx blob
 *
 * @since 20230810
 */
async function baixarModeloImportacaoItem(tipo: string): Promise<Blob> {
  const response = await Service.$http.get(
    process.env.VUE_APP_LICITACOES_API +
    `/licitacao/baixarModeloImportacao/${tipo}`,
    { responseType: "blob" }
  );
  // console.log("ldiService.baixarModeloImportacaoItem recebeu", response);
  if (response && response.status === 200) return response.data;
  console.error(
    "falha ao baixar modelo de importação de itens/lotes",
    tipo,
    response
  );
  throw new PortalError(response.data.msg ?? response);
}

/**
 *
 * @param objRetornoImportacao {RetornoImportarLicitacoes}
 * @returns pdf blob
 *
 * @since 20231124
 */
async function baixarRelatorioInconsistencias(
  ril: RetornoImportarLicitacoes
): Promise<Blob> {
  const response = await Service.$http.post(
    process.env.VUE_APP_LICITACOES_API +
    "/licitacao/relatoriodeinconsistencias",
    ril,
    { responseType: "blob" }
  );
  //console.log("ldiService.baixarRelatorioInconsistencias recebeu", response);
  if (response && response.status === 200) return response.data;
  console.error(
    "falha ao baixar relatório de inconsistências de importação de licitações",
    response
  );
  throw new PortalError(response.data.msg ?? response);
}

async function baixarRelatorioPendencias(
  ril: RetornoImportarLicitacoes
): Promise<Blob> {
  const response = await Service.$http.post(
    process.env.VUE_APP_LICITACOES_API +
    "/licitacao/relatoriodependencias",
    ril.listaPendencias,
    { responseType: "blob" }
  );
  //console.log("ldiService.baixarRelatorioInconsistencias recebeu", response);
  if (response && response.status === 200) return response.data;
  console.error(
    "falha ao baixar relatório de pendências de importação de licitações",
    response
  );
  throw new PortalError(response.data.msg ?? response);
}
// FIM métodos de importação

/**
 * Opções de cancelamento disponíveis para esta licitação
 * @param idLicitacao
 * @returns {desercao: boolean, fracasso: boolean}
 *
 * @since 20230823
 */
async function buscarOpcoesDeCancelamento(idLicitacao: number): Promise<any> {
  const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/opcoesCancelamento/${idLicitacao}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200) {
    return response.data;
  } else {
    console.error(response);
    throw new PortalError(
      "Falha ao buscar opções de cancelamento disponíveis para esta licitação."
    );
  }
}

/**
 * Solicita o cancelamento (lógico) de LDI
 *
 * @since 20230823
 */
async function cancelarLdi(cDto: CancelamentoLicitacaoDto): Promise<boolean> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/anularLicitacao/${cDto.IdLicitacao}`;
    const response = await Service.$http.post(url, cDto.toFormData());
    if (response && response.status === 200) {
      return response.data;
    }
    console.error(response);
    throw new PortalError("Falha ao tentar cancelar a licitação.");
  } catch (e: any) {
    console.error("capotou no service", e);
    if ([400, 403].includes(e.response?.status)) {
      throw montarArrayDeErros(e);
    }
    throw e;
  }
}

async function buscarInformacoesCancelamento(
  idLicitacao: number
): Promise<LicitacaoDadosCancelamento> {
  const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarInformacoesCancelamento/${idLicitacao}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200) {
    const ldc = Object.assign(new LicitacaoDadosCancelamento(), response.data);
    ldc.tratarDadosDaAPI();
    return ldc;
  } else {
    console.error(response);
    throw new PortalError(
      "Falha ao buscar dados de cancelamento desta licitação."
    );
  }
}

/**
 * Solicita o DEScancelamento (lógico) de uma LDI
 *
 * @since 20230825
 */
async function cancelarLdiCancelada(idl: number): Promise<boolean> {
  const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/cancelarAnulacao/${idl}`;
  const response = await Service.$http.post(url);
  if (response && response.status === 200) {
    return response.data;
  } else {
    console.error(response);
    throw new PortalError("Falha ao tentar descancelar a licitação.");
  }
}

/**
 * Pega a situação de uma licitação
 *
 * @since 20231106
 */
async function buscarSituacao(id: number): Promise<string> {
  const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/buscarSituacao/${id}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200) {
    return response.data.FlSituacao;
  } else {
    console.error(response);
    throw new PortalError("Falha ao obter status da licitação.");
  }
}

async function removerLicitacao(id: number): Promise<boolean> {
  try {
    const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/removerLicitacao/${id}`;
    const response = await Service.$http.delete(url);
    return response.status === 204;
  } catch (e: any) {
    console.error("Erro ao tentar remover licitação", e);
    if (e.response.status === 400 || e.response.status === 403) {
      throw new PortalError(e.response.data.erros ?? e.response.data.msg);
    } else {
      throw e;
    }
  }
}

/** Obtém uma lista de pendências (string array) para que uma licitação em cadastramento possa se tornar finalizada. */
async function listarPendenciasLicitacao(id: number): Promise<string[]> {
  const url = `${process.env.VUE_APP_LICITACOES_API}/licitacao/pendencias/${id}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200) return response.data;
  console.error(response);
  throw new PortalError("Falha ao obter pendências da licitação.");
}

//
//métodos privados
//
function montarLote(respData: any): LoteLicitacao {
  const novoLote = Object.assign(new LoteLicitacao(), respData.lote);
  novoLote.QtItens = respData.qtdItensLote ?? respData.QtdItens;
  novoLote.VlTotalEstimado = respData.vlTotalEstimado;
  novoLote.VlTotalLicitado = respData.vlTotalLicitado;
  return novoLote;
}
function montarArrayDeErros(e: any): PortalError {
  if (e.response.data.erros) return new PortalError(e.response.data.erros);
  if (e.response.data.msg) return new PortalError(e.response.data.msg);
  return new PortalError(e);
}

async function getListaTldPaises(): Promise<{ Sigla: string; Descricao: string }[]> {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_LICITACOES_API + "/licitacao/getListaTldPaises"
    );
    if (response && response.status === 200) return response.data;
    return [];
  } catch (e: any) {
    console.error("Erro ao buscar lista de TLD de países", e);
    return [];
  }
}

export default ldiService;
